import { fetchTagsSuccess } from './fetch-tags';
export const tagsReducer = (state = [], action) => {
    switch (action.type) {
        case fetchTagsSuccess.type:
            return action.payload;
        default:
            return state;
    }
};
export default tagsReducer;
//# sourceMappingURL=tags-reducer.js.map